var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteHeartLineOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_7262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5H25V25.5H1V1.5Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5154 8.30799L17.5155 8.30805C18.7519 9.02898 19.6903 10.545 19.6483 12.3849C19.6004 14.5322 17.9101 16.7406 14.1661 18.9645C14.0984 19.0048 14.0296 19.0478 13.9572 19.0931L13.9433 19.1018C13.6914 19.2594 13.3931 19.4461 13.067 19.5368L13 19.5554L12.933 19.5368C12.6069 19.4461 12.3086 19.2594 12.0567 19.1018L12.0428 19.0931C11.9704 19.0478 11.9016 19.0048 11.8339 18.9645C11.8339 18.9644 11.8338 18.9644 11.8337 18.9643L17.5154 8.30799ZM17.5154 8.30799C16.9175 7.95969 16.2361 7.78701 15.5362 7.87162C14.8349 7.9564 14.1346 8.29716 13.4969 8.94232C13.4318 9.00761 13.3544 9.05942 13.2692 9.0948C13.1839 9.13023 13.0924 9.14848 13 9.14848C12.9076 9.14848 12.8161 9.13024 12.7308 9.0948C12.6456 9.05941 12.5682 9.00757 12.503 8.94225C11.8653 8.29713 11.1651 7.9564 10.4638 7.87162C9.76393 7.78701 9.08254 7.95969 8.4846 8.30799L8.4845 8.30805C7.24805 9.02902 6.31055 10.5443 6.35171 12.3856M17.5154 8.30799L6.35171 12.3856M6.35171 12.3856C6.35171 12.3856 6.35171 12.3856 6.35171 12.3856L6.60164 12.38L6.35171 12.3856ZM14.7275 19.9098L14.7275 19.9098C14.6454 19.9586 14.5631 20.0092 14.4819 20.0591L14.4811 20.0596C13.9718 20.3726 13.5083 20.6499 13 20.6499C12.4976 20.6499 12.0129 20.3612 11.5009 20.0479L11.5002 20.0475C11.424 20.0009 11.3474 19.954 11.2717 19.909L11.2717 19.909C7.45774 17.6439 5.31331 15.1587 5.25159 12.4088L5.25159 12.4088C5.20156 10.183 6.33601 8.28706 7.93068 7.35684C9.41539 6.49256 11.2712 6.48675 12.8423 7.76438L13 7.89265L13.1577 7.76438C14.7289 6.48668 16.5847 6.49182 18.0693 7.35683C19.6639 8.2862 20.7984 10.1829 20.7484 12.4088C20.6867 15.1595 18.5431 17.6439 14.7275 19.9098Z",
    fill: "#066D0E",
    stroke: "#066D0E",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#F8F8F8",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_7262"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteHeartLineOn);
export default __webpack_public_path__ + "static/media/mingcute-heart-line-on.9e4b3f758c47626175274a40a2fcb91a.svg";
export { ForwardRef as ReactComponent };